import React,{useState} from 'react';
import { BrowserRouter as Router,
  Switch,
  Route,
  } from "react-router-dom";
import './App.css';

import Home from "./pages/Home/Home";
import Products from "./pages/Products/Products";
import ProductDescription from './pages/ProductDescription/ProductDescription';
import AddPage from "./pages/AddPage/AddPage";
import db from "../src/data/firebase";
import EditPage from "../src/pages/EditPage/EditPage";


function App() {
  const [perfumes, setPerfumes]= useState();
  const [individual, setIndividual]=useState();
  // const [searchedPerfume, setSearchedPerfume]=useState();
    
  let perfumeList=[];
  

  function checking(){
      let i=0;
      db.collection("perfumes").get().then(function(querySnapshot) {
          querySnapshot.forEach(function(doc) {
              
              let temp={
                  id: doc.id,
                  data: doc.data(),
              }
              perfumeList[i]=temp;
              i++;
              
          });
          setPerfumes(perfumeList);
          
  
      });
  }
 
  let temp=null;


  function getProduct(product){
    if(product.id===perfumes[0].id){
      setIndividual(perfumeList[0]);
      alert(individual.id);
    }
    
    
    
  }

  

  return (
   
    <div className="App">
    {perfumes? null: checking()}
    
      
         
      <React.Fragment>
        <Router>
        <Switch>
            <Route path="/products">
              <Products getProduct={getProduct} />
            </Route>
            <Route exact path="/adminedit/rifatnrakib">
              <Products  getProduct={getProduct} />
              
              
              {/* <EditPage/> */}
             
            </Route>

            <Route path="/adminedit/rifatnrakib/desc">
            
              
              
              <EditPage/>
             
            </Route>

            <Route path="/desc">
              <ProductDescription selected={temp} select={individual}/>
              
             
            </Route>

            <Route exact path="/adminedit/rifatnrakib/add">
              <AddPage/>
            </Route>

            <Route exact path="/">
              <Home />
            </Route>
        </Switch>
        </Router>
      </React.Fragment>
    
      
    </div>
  );
}

export default App;
